import { new__cn as cn, createTwStyle } from '../util';
import { DRAWER_SIZE } from './constant';
import type { VDrawerProps } from './type';

const twStyle = createTwStyle<VDrawerProps>();

export default twStyle({
  main: ({ size = DRAWER_SIZE.MD }) => [
    cn({
      'w-[1036px]': size === DRAWER_SIZE.MD,
    }),
  ],
});
